var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "bvModal",
      attrs: {
        id: "staff_form_modal",
        "no-close-on-backdrop": true,
        "hide-footer": true,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c("div", { staticClass: "modal-header-buttons-container" }, [
                _c(
                  "button",
                  {
                    staticClass: "close-modal-btn mr-7",
                    attrs: { id: "staff_form_modal_close_btn" },
                    on: {
                      click: function ($event) {
                        return close()
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "feather feather-x",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "28",
                          height: "28",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("line", {
                          attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                        }),
                        _c("line", {
                          attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                        }),
                      ]
                    ),
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "bb-btn btn-success header-save-btn",
                    on: {
                      click: function ($event) {
                        return _vm.submit()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.submitBtnText) + " ")]
                ),
              ]),
              _c("div", { staticClass: "modal-header-title-container" }, [
                _c("h2", [_vm._v(_vm._s(_vm.modalTitle))]),
              ]),
            ]
          },
        },
      ]),
    },
    [
      _c("div", { staticClass: "bb-card basic-info-card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h2", { staticClass: "card-title" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("calendarFormModal.basicInfoCard.title")) +
                " "
            ),
          ]),
        ]),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "card-inputs-container" }, [
            _c("div", { staticClass: "bb-form-group" }, [
              _c("label", [
                _vm._v(
                  _vm._s(
                    _vm.$t("calendarFormModal.basicInfoCard.nameInput.label")
                  )
                ),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.fields.name,
                    expression: "form.fields.name",
                  },
                ],
                staticClass: "bb-input",
                attrs: { type: "text" },
                domProps: { value: _vm.form.fields.name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form.fields, "name", $event.target.value)
                  },
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.name,
                      expression: "form.errors.name",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("calendarFormModal.validation.error")) +
                      " "
                  ),
                ]
              ),
            ]),
            _c("div", { staticClass: "bb-form-group" }, [
              _c("label", [
                _vm._v(
                  _vm._s(
                    _vm.$t("calendarFormModal.basicInfoCard.titleInput.label")
                  )
                ),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.fields.title,
                    expression: "form.fields.title",
                  },
                ],
                staticClass: "bb-input",
                attrs: { type: "text" },
                domProps: { value: _vm.form.fields.title },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form.fields, "title", $event.target.value)
                  },
                },
              }),
              _c("p", { staticClass: "bb-input-description" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "calendarFormModal.basicInfoCard.titleInput.description"
                      )
                    ) +
                    " "
                ),
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.title,
                      expression: "form.errors.title",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("calendarFormModal.validation.error")) +
                      " "
                  ),
                ]
              ),
            ]),
            _c(
              "div",
              { staticClass: "bb-form-group" },
              [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("calendarFormModal.basicInfoCard.notesInput.label")
                    ) + " "
                  ),
                  _c("span", { staticClass: "label-description" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "calendarFormModal.basicInfoCard.notesInput.labelDescription"
                        )
                      )
                    ),
                  ]),
                ]),
                _c("b-form-textarea", {
                  staticClass: "bb-textarea",
                  attrs: {
                    rows: "5",
                    placeholder: _vm.$t(
                      "calendarFormModal.basicInfoCard.notesInput.placeholder"
                    ),
                  },
                  model: {
                    value: _vm.form.fields.toc,
                    callback: function ($$v) {
                      _vm.$set(_vm.form.fields, "toc", $$v)
                    },
                    expression: "form.fields.toc",
                  },
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.errors.toc,
                        expression: "form.errors.toc",
                      },
                    ],
                    staticClass: "bb-invalid-feedback",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("calendarFormModal.validation.error")) +
                        " "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c("hr"),
          _c("div", { staticClass: "card-inputs-container" }, [
            _c("p", { staticClass: "card-subtitle" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("calendarFormModal.basicInfoCard.contactTitle")
                  ) +
                  " "
              ),
            ]),
            _c("span", { staticClass: "card-subtitle-description" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("calendarFormModal.basicInfoCard.contactDescription")
                )
              ),
            ]),
            _c("div", { staticClass: "form-groups-holder" }, [
              _c("div", { staticClass: "bb-form-group" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "calendarFormModal.basicInfoCard.firstNameInput.label"
                      )
                    )
                  ),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.fields.firstName,
                      expression: "form.fields.firstName",
                    },
                  ],
                  staticClass: "bb-input",
                  attrs: { type: "text" },
                  domProps: { value: _vm.form.fields.firstName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.form.fields,
                        "firstName",
                        $event.target.value
                      )
                    },
                  },
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.errors.firstName,
                        expression: "form.errors.firstName",
                      },
                    ],
                    staticClass: "bb-invalid-feedback",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("calendarFormModal.validation.error")) +
                        " "
                    ),
                  ]
                ),
              ]),
              _c("div", { staticClass: "bb-form-group" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "calendarFormModal.basicInfoCard.lastNameInput.label"
                      )
                    )
                  ),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.fields.lastName,
                      expression: "form.fields.lastName",
                    },
                  ],
                  staticClass: "bb-input",
                  attrs: { type: "text" },
                  domProps: { value: _vm.form.fields.lastName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form.fields, "lastName", $event.target.value)
                    },
                  },
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.errors.lastName,
                        expression: "form.errors.lastName",
                      },
                    ],
                    staticClass: "bb-invalid-feedback",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("calendarFormModal.validation.error")) +
                        " "
                    ),
                  ]
                ),
              ]),
            ]),
            _c("div", { staticClass: "form-groups-holder" }, [
              _c("div", { staticClass: "bb-form-group" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("calendarFormModal.basicInfoCard.emailInput.label")
                    )
                  ),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.fields.email,
                      expression: "form.fields.email",
                    },
                  ],
                  staticClass: "bb-input",
                  attrs: { type: "email", placeholder: "mail@example.com" },
                  domProps: { value: _vm.form.fields.email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form.fields, "email", $event.target.value)
                    },
                  },
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.errors.email,
                        expression: "form.errors.email",
                      },
                    ],
                    staticClass: "bb-invalid-feedback",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("calendarFormModal.validation.error")) +
                        " "
                    ),
                  ]
                ),
              ]),
              _c("div", { staticClass: "bb-form-group" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("calendarFormModal.basicInfoCard.phoneInput.label")
                    )
                  ),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.fields.phone,
                      expression: "form.fields.phone",
                    },
                  ],
                  staticClass: "bb-input",
                  attrs: { type: "text" },
                  domProps: { value: _vm.form.fields.phone },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form.fields, "phone", $event.target.value)
                    },
                  },
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.errors.phone,
                        expression: "form.errors.phone",
                      },
                    ],
                    staticClass: "bb-invalid-feedback",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("calendarFormModal.validation.error")) +
                        " "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
          _c("hr"),
          _c("div", { staticClass: "card-inputs-container" }, [
            _c("p", { staticClass: "card-subtitle" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("calendarFormModal.basicInfoCard.employmentTitle")
                  ) +
                  " "
              ),
            ]),
            _c("div", { staticClass: "form-groups-holder" }, [
              _c("div", { staticClass: "bb-form-group" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "calendarFormModal.basicInfoCard.employmentStartInput.label"
                      )
                    )
                  ),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.fields.employmentStartDate,
                      expression: "form.fields.employmentStartDate",
                    },
                  ],
                  staticClass: "bb-input",
                  attrs: { type: "date", max: _vm.employmentStartDateMax },
                  domProps: { value: _vm.form.fields.employmentStartDate },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.form.fields,
                        "employmentStartDate",
                        $event.target.value
                      )
                    },
                  },
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.errors.employmentStartDate,
                        expression: "form.errors.employmentStartDate",
                      },
                    ],
                    staticClass: "bb-invalid-feedback",
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.form.errors.employmentStartDate) + " "
                    ),
                  ]
                ),
              ]),
              _c("div", { staticClass: "bb-form-group" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "calendarFormModal.basicInfoCard.employmentEndInput.label"
                      )
                    )
                  ),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.fields.employmentEndDate,
                      expression: "form.fields.employmentEndDate",
                    },
                  ],
                  staticClass: "bb-input",
                  attrs: { type: "date", min: _vm.employmentEndDateMin },
                  domProps: { value: _vm.form.fields.employmentEndDate },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.form.fields,
                        "employmentEndDate",
                        $event.target.value
                      )
                    },
                  },
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.errors.employmentEndDate,
                        expression: "form.errors.employmentEndDate",
                      },
                    ],
                    staticClass: "bb-invalid-feedback",
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.form.errors.employmentEndDate) + " "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "bb-card places-card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h2", { staticClass: "card-title" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("calendarFormModal.placesCard.title")) + " "
            ),
          ]),
          _c("span", { staticClass: "card-description" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("calendarFormModal.placesCard.description"))
            ),
          ]),
        ]),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "card-inputs-container" }, [
            _c(
              "div",
              { staticClass: "bb-form-group" },
              [
                _c("BBCheckboxGroup", {
                  attrs: {
                    options: _vm.placesAsOptions,
                    elementId: "places_checkboxes",
                    allCheckedLabel: _vm.$t(
                      "calendarFormModal.placesCard.placesInput.allLabel"
                    ),
                  },
                  model: {
                    value: _vm.form.fields.placeIds,
                    callback: function ($$v) {
                      _vm.$set(_vm.form.fields, "placeIds", $$v)
                    },
                    expression: "form.fields.placeIds",
                  },
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.errors.placeIds,
                        expression: "form.errors.placeIds",
                      },
                    ],
                    staticClass: "bb-invalid-feedback",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("calendarFormModal.validation.error")) +
                        " "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "bb-card booking-card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h2", { staticClass: "card-title" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("calendarFormModal.bookingCard.title")) + " "
            ),
          ]),
        ]),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "card-inputs-container" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.currentUser.isInLawIndustry,
                    expression: "!currentUser.isInLawIndustry",
                  },
                ],
                staticClass: "bb-form-group",
              },
              [
                _c("BBSwitch", {
                  attrs: {
                    label: _vm.$t(
                      "calendarFormModal.bookingCard.bookingsEnabledInput.label"
                    ),
                  },
                  model: {
                    value: _vm.form.fields.onlineBookings,
                    callback: function ($$v) {
                      _vm.$set(_vm.form.fields, "onlineBookings", $$v)
                    },
                    expression: "form.fields.onlineBookings",
                  },
                }),
                _c(
                  "p",
                  {
                    staticClass: "bb-input-description",
                    staticStyle: { "margin-left": "76px" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "calendarFormModal.bookingCard.bookingsEnabledInput.description"
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.errors.onlineBookings,
                        expression: "form.errors.onlineBookings",
                      },
                    ],
                    staticClass: "bb-invalid-feedback",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("calendarFormModal.validation.error")) +
                        " "
                    ),
                  ]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "bb-form-group" }, [
              _c("label", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "calendarForm.advancedSettings.cancellationMarginInput.label"
                    )
                  )
                ),
              ]),
              _c("p", { staticClass: "bb-input-description" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "calendarForm.advancedSettings.cancellationMarginInput.description"
                      )
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "margin-wrapper" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-start align-items-center",
                  },
                  [
                    _c("BBSelect", {
                      attrs: { options: _vm.daysOptions },
                      model: {
                        value: _vm.form.helpers.cancellationMarginObject.days,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.helpers.cancellationMarginObject,
                            "days",
                            $$v
                          )
                        },
                        expression:
                          "\n                                    form.helpers.cancellationMarginObject\n                                        .days\n                                ",
                      },
                    }),
                    _c("span", { staticClass: "cancellation-margin-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "calendarForm.advancedSettings.cancellationMarginInput.daysLabel"
                          )
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-start align-items-center",
                  },
                  [
                    _c("BBSelect", {
                      attrs: { options: _vm.hoursOptions },
                      model: {
                        value: _vm.form.helpers.cancellationMarginObject.hours,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.helpers.cancellationMarginObject,
                            "hours",
                            $$v
                          )
                        },
                        expression:
                          "\n                                    form.helpers.cancellationMarginObject\n                                        .hours\n                                ",
                      },
                    }),
                    _c("span", { staticClass: "cancellation-margin-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "calendarForm.advancedSettings.cancellationMarginInput.hoursLabel"
                          )
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-start align-items-center",
                  },
                  [
                    _c("BBSelect", {
                      attrs: { options: _vm.minutesOptions },
                      model: {
                        value:
                          _vm.form.helpers.cancellationMarginObject.minutes,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.helpers.cancellationMarginObject,
                            "minutes",
                            $$v
                          )
                        },
                        expression:
                          "\n                                    form.helpers.cancellationMarginObject\n                                        .minutes\n                                ",
                      },
                    }),
                    _c("span", { staticClass: "cancellation-margin-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "calendarForm.advancedSettings.cancellationMarginInput.minutesLabel"
                          )
                        )
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.cancellationMargin,
                      expression: "form.errors.cancellationMargin",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [_vm._v(" " + _vm._s(_vm.form.errors.cancellationMargin) + " ")]
              ),
            ]),
            _c("div", { staticClass: "bb-form-group" }, [
              _c("label", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "calendarForm.advancedSettings.bookingMarginInput.label"
                    )
                  )
                ),
              ]),
              _c("p", { staticClass: "bb-input-description" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "calendarForm.advancedSettings.bookingMarginInput.description"
                      )
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "margin-wrapper" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-start align-items-center",
                  },
                  [
                    _c("BBSelect", {
                      attrs: { options: _vm.daysOptions },
                      model: {
                        value: _vm.form.helpers.bookingMarginObject.days,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.helpers.bookingMarginObject,
                            "days",
                            $$v
                          )
                        },
                        expression:
                          "\n                                    form.helpers.bookingMarginObject.days\n                                ",
                      },
                    }),
                    _c("span", { staticClass: "cancellation-margin-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "calendarForm.advancedSettings.bookingMarginInput.daysLabel"
                          )
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-start align-items-center",
                  },
                  [
                    _c("BBSelect", {
                      attrs: { options: _vm.hoursOptions },
                      model: {
                        value: _vm.form.helpers.bookingMarginObject.hours,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.helpers.bookingMarginObject,
                            "hours",
                            $$v
                          )
                        },
                        expression:
                          "\n                                    form.helpers.bookingMarginObject.hours\n                                ",
                      },
                    }),
                    _c("span", { staticClass: "cancellation-margin-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "calendarForm.advancedSettings.bookingMarginInput.hoursLabel"
                          )
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-start align-items-center",
                  },
                  [
                    _c("BBSelect", {
                      attrs: { options: _vm.minutesOptions },
                      model: {
                        value: _vm.form.helpers.bookingMarginObject.minutes,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.helpers.bookingMarginObject,
                            "minutes",
                            $$v
                          )
                        },
                        expression:
                          "\n                                    form.helpers.bookingMarginObject.minutes\n                                ",
                      },
                    }),
                    _c("span", { staticClass: "cancellation-margin-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "calendarForm.advancedSettings.bookingMarginInput.minutesLabel"
                          )
                        )
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.bookingMargin,
                      expression: "form.errors.bookingMargin",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [_vm._v(" " + _vm._s(_vm.form.errors.bookingMargin) + " ")]
              ),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "bb-card color-card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h2", { staticClass: "card-title" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("calendarFormModal.colorCard.title")) + " "
            ),
          ]),
          _c("span", { staticClass: "card-description" }, [
            _vm._v(_vm._s(_vm.$t("calendarFormModal.colorCard.description"))),
          ]),
        ]),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "card-inputs-container" }, [
            _c("div", { staticClass: "bb-form-group" }, [
              _c("label", [
                _vm._v(
                  _vm._s(_vm.$t("calendarFormModal.colorCard.colorInput.label"))
                ),
              ]),
              _c(
                "div",
                { staticClass: "colors-container" },
                _vm._l(_vm.availableColors, function (color, index) {
                  return _c("div", {
                    key: index,
                    staticClass: "bb-badge badge-rounded badge-sm",
                    class: _vm.form.fields.color === color ? "selected" : "",
                    style: "background: " + color,
                    on: {
                      click: function ($event) {
                        return _vm.setColor(color)
                      },
                    },
                  })
                }),
                0
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.color,
                      expression: "form.errors.color",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("calendarFormModal.validation.error")) +
                      " "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "bb-card services-card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h2", { staticClass: "card-title" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("calendarFormModal.servicesCard.title")) + " "
            ),
          ]),
          _c("span", { staticClass: "card-description" }, [
            _vm._v(
              _vm._s(_vm.$t("calendarFormModal.servicesCard.description"))
            ),
          ]),
        ]),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "card-inputs-container" }, [
            _c("div", { staticClass: "services-input-container" }, [
              _c("div", { staticClass: "choosen-services-container" }, [
                _c("span", [_vm._v(_vm._s(_vm.selectedServicesText))]),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.fields.serviceIds.length > 0,
                        expression: "form.fields.serviceIds.length > 0",
                      },
                    ],
                    staticClass: "selected-services-count",
                  },
                  [
                    _vm._v(
                      " (" + _vm._s(_vm.form.fields.serviceIds.length) + ")"
                    ),
                  ]
                ),
              ]),
              _c(
                "button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.openServicesModal()
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "calendarFormModal.servicesCard.servicesInput.editBtn"
                        )
                      ) +
                      " "
                  ),
                ]
              ),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.errors.serviceIds,
                    expression: "form.errors.serviceIds",
                  },
                ],
                staticClass: "bb-invalid-feedback",
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("calendarFormModal.validation.error")) +
                    " "
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "bb-card services-card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h2", { staticClass: "card-title" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("calendarFormModal.clientsCard.title")) + " "
            ),
          ]),
          _c("span", { staticClass: "card-description" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("calendarFormModal.clientsCard.description")) +
                " "
            ),
          ]),
        ]),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "card-inputs-container" }, [
            _c("div", { staticClass: "services-input-container" }, [
              _c("div", { staticClass: "choosen-services-container" }, [
                _c("span", [_vm._v(_vm._s(_vm.selectedClientsText))]),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.fields.clientProfileIds.length > 0,
                        expression: "form.fields.clientProfileIds.length > 0",
                      },
                    ],
                    staticClass: "selected-services-count",
                  },
                  [
                    _vm._v(
                      " (" +
                        _vm._s(_vm.form.fields.clientProfileIds.length) +
                        ")"
                    ),
                  ]
                ),
              ]),
              _c(
                "button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.openClientProfilesModal()
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "calendarFormModal.clientsCard.clientsInput.editBtn"
                        )
                      ) +
                      " "
                  ),
                ]
              ),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.errors.clientProfileIds,
                    expression: "form.errors.clientProfileIds",
                  },
                ],
                staticClass: "bb-invalid-feedback",
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("calendarFormModal.validation.error")) +
                    " "
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "bb-card permissions-card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h2", { staticClass: "card-title" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("calendarFormModal.permissionsCard.title")) +
                " "
            ),
          ]),
        ]),
        _c("div", { staticClass: "card-body" }, [
          _c(
            "div",
            { staticClass: "card-inputs-container" },
            [
              _c("p", { staticClass: "permission-value" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.permissionsLabels[_vm.form.helpers.permission]) +
                    " "
                ),
              ]),
              _c("v-slider", {
                attrs: {
                  "tick-labels": _vm.permissionsLabels,
                  max: 3,
                  step: "1",
                  ticks: "always",
                  "tick-size": "8",
                  color: "#1A73E8",
                  "data-app": "app",
                  height: "50",
                },
                model: {
                  value: _vm.form.helpers.permissionValue,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.helpers, "permissionValue", $$v)
                  },
                  expression: "form.helpers.permissionValue",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.errors.permissions,
                  expression: "form.errors.permissions",
                },
              ],
              staticClass: "bb-invalid-feedback",
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("calendarFormModal.validation.error")) + " "
              ),
            ]
          ),
        ]),
      ]),
      _c(
        "b-modal",
        {
          ref: "selectServicesModal",
          attrs: { id: "select_services_modal", "no-close-on-backdrop": true },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function ({ close }) {
                return [
                  _c("div", { staticClass: "modal-header-title-container" }, [
                    _c("h2", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "calendarFormModal.selectServicesModal.title"
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "close-modal-btn mr-7",
                      attrs: { id: "select_services_modal_close_btn" },
                      on: {
                        click: function ($event) {
                          close()
                          _vm.resetSelectedServices()
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "feather feather-x",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "28",
                            height: "28",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("line", {
                            attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                          }),
                          _c("line", {
                            attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]
              },
            },
            {
              key: "modal-footer",
              fn: function ({ close }) {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "bb-btn btn-outline",
                      on: {
                        click: function ($event) {
                          close()
                          _vm.resetSelectedServices()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "calendarFormModal.selectServicesModal.closeBtn"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "bb-btn btn-success",
                      on: {
                        click: function ($event) {
                          close()
                          _vm.setSelectedServices()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "calendarFormModal.selectServicesModal.saveBtn"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c("div", { staticClass: "search-services-container" }, [
            _c("div", { staticClass: "bb-input-group search-services-input" }, [
              _c("i", { staticClass: "fas fa-search" }),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.servicesSearch,
                    expression: "servicesSearch",
                  },
                ],
                attrs: {
                  type: "text",
                  placeholder: _vm.$t(
                    "calendarFormModal.selectServicesModal.searchInput.placeholder"
                  ),
                },
                domProps: { value: _vm.servicesSearch },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.servicesSearch = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "services-list" },
            [
              _c("BBCheckboxGroup", {
                ref: "serviceCheckboxes",
                attrs: {
                  options: _vm.servicesOptions,
                  allCheckedLabel: _vm.$t(
                    "calendarFormModal.selectServicesModal.allServicesLabel"
                  ),
                  elementId: "service_checkboxes",
                },
                model: {
                  value: _vm.form.fields.serviceIds,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.fields, "serviceIds", $$v)
                  },
                  expression: "form.fields.serviceIds",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          ref: "selectClientProfilesModal",
          attrs: { id: "select_clients_modal", "no-close-on-backdrop": true },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function ({ close }) {
                return [
                  _c("div", { staticClass: "modal-header-title-container" }, [
                    _c("h2", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("calendarFormModal.selectClientsModal.title")
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "close-modal-btn mr-7",
                      attrs: { id: "select_clients_modal_close_btn" },
                      on: {
                        click: function ($event) {
                          close()
                          _vm.resetSelectedClientProfiles()
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "feather feather-x",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "28",
                            height: "28",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("line", {
                            attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                          }),
                          _c("line", {
                            attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]
              },
            },
            {
              key: "modal-footer",
              fn: function ({ close }) {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "bb-btn btn-outline",
                      on: {
                        click: function ($event) {
                          close()
                          _vm.resetSelectedClientProfiles()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "calendarFormModal.selectClientsModal.closeBtn"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "bb-btn btn-success",
                      on: {
                        click: function ($event) {
                          close()
                          _vm.setSelectedClientProfiles()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "calendarFormModal.selectClientsModal.saveBtn"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c("div", { staticClass: "search-clients-container" }, [
            _c("div", { staticClass: "bb-input-group search-clients-input" }, [
              _c("i", { staticClass: "fas fa-search" }),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.clientProfileSearch,
                    expression: "clientProfileSearch",
                  },
                ],
                attrs: {
                  type: "text",
                  placeholder: _vm.$t(
                    "calendarFormModal.selectClientsModal.searchInput.placeholder"
                  ),
                },
                domProps: { value: _vm.clientProfileSearch },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.clientProfileSearch = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "clients-list" },
            [
              _c("BBCheckboxGroup", {
                ref: "clientProfilesCheckboxes",
                attrs: {
                  options: _vm.clientsAsOptions,
                  allCheckedLabel: _vm.$t(
                    "calendarFormModal.selectClientsModal.allClientsLabel"
                  ),
                  elementId: "clients_checkboxes",
                },
                model: {
                  value: _vm.form.fields.clientProfileIds,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.fields, "clientProfileIds", $$v)
                  },
                  expression: "form.fields.clientProfileIds",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "mobile-footer" }, [
        _c(
          "button",
          {
            staticClass: "bb-btn btn-success",
            on: {
              click: function ($event) {
                return _vm.submit()
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.submitBtnText) + " ")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }